import vueComponentOptions from 'components/InputRadio.vue';

const RadioInput = Vue.extend(vueComponentOptions);

module.exports = RadioInput;
